"use strict";

import $ from "jquery";

export default function scrollLine(scope) {
    $(scope).each(function () {
        $(window).scroll(() => {
            const scrolled =
                100 -
                ($(window).scrollTop() /
                    ($(document).height() - $(window).height())) *
                    100;
            $(this).css("transform", "translate3d(-" + scrolled + "%, 0, 0)");
        });
    });
}
